import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  //   const isAuthenticated = localStorage.getItem("token"); // Assuming you store the auth token in localStorage
  const hasSubmittedAnswers = localStorage.getItem("answersSubmitted"); // You'll need to set this flag when answers are submitted
  const lastActivity = parseInt(
    localStorage.getItem("lastActivityTime") || "0"
  );
  const SESSION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  // Check if session has timed out
  if (Date.now() - lastActivity > SESSION_TIMEOUT) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  if (!hasSubmittedAnswers) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
